import { useEffect, useState } from 'react';

// Components
import AddEditEducation from '../../components/AddEditEducation';
import CustomDataTable from '../../components/DataTable';

// Constants
import { EDUCATIONS_COLUMNS, GRADE_CODE } from '../../constants/general';

// Utility Functions
import { deleteEducation, getEducationDetailsData } from '../../middleware/educationDetails';

// Utility Packages
import moment from 'moment/moment';
import { Button } from 'primereact/button';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { useSelector } from 'react-redux';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { Actions } from '../../redux/actions';
import { dispatch } from '../../utils/store';

// images
import deleteIcon from '../../assets/images/grid-delete-icon.svg';
import editIcon from '../../assets/images/grid-edit-icon.svg';

function EducationDetails() {
  // Store
  const toastReff = useSelector((state) => state.notifications.toastReff);
  const { educations, totalRecords, search, pageNumber, size } = useSelector(
    (state) => state.educationDetails
  );

  // State
  const [educationModal, setEducationModal] = useState(false);
  const [educationsDetails, setEducationsDetails] = useState([]);
  const [selectedEducation, setSelectedEducation] = useState(null);
  const [deleteEducationModal, setDeleteEducationModal] = useState(false);

  useEffect(
    () => getEducationDetailsData(search, pageNumber, size, toastReff),
    [search, pageNumber, size]
  );

  const onEditClick = (education) => {
    setSelectedEducation(education);
    setEducationModal(true);
  };

  const onDeleteClick = (education) => {
    setSelectedEducation(education);
    setDeleteEducationModal(true);
  };

  useEffect(() => {
    return () => {
      dispatch(Actions.Educations.EducationsReset);
    };
  }, []);
  useEffect(() => {
      const modifiedRecords = educations?.map((education) => {
        return {
          ...education,
          Details: education.Details ? education.Details : '--',
          Course: education.Course ? education.Course : '--',
          University: education.University ? education.University : '--',
          StartDate: education.StartDate ? moment(education.StartDate).format('MM/yyyy') : '--',
          EndDate: education.EndDate ? moment(education.EndDate).format('MM/yyyy') : '--',
          Grade: education.Grade ? GRADE_CODE[education.Grade] : '--',
          action: (
            <div className="table-actions-wrapper">
              <Button
          data-tooltip-id="edit-button"
          data-tooltip-content="Edit"
          rounded
          text
          severity="secondary"
          aria-label="Edit"
          onClick={() => onEditClick(education)}
          className="grid-action-btn">
          <em>
            <img src={editIcon} alt="edit icon" />
          </em>
              </Button>
              <Button
          data-tooltip-id="delete-button"
          data-tooltip-content="Delete"
          rounded
          text
          aria-label="Delete"
          onClick={() => onDeleteClick(education)}
          className="grid-action-btn">
          <em>
            <img src={deleteIcon} alt="delete icon" />
          </em>
              </Button>
              <ReactTooltip id="edit-button" place="top" />
              <ReactTooltip id="delete-button" place="top" />
            </div>
          )
        };
      });
      setEducationsDetails(modifiedRecords);
  }, [educations]);

  const handlePagination = (pageNumber, size) => {
    dispatch(Actions.Educations.SetPageNumber, pageNumber);
    dispatch(Actions.Educations.SetPageSize, size);
  };

  const handleSearch = (searchValue) => {
    dispatch(Actions.Educations.SetSearch, searchValue);
  };

  return (
    <>
      <ConfirmDialog
        header="Delete"
        message="Are you sure you want to delete?"
        icon="pi pi-exclamation-triangle"
        visible={deleteEducationModal}
        onHide={() => {
          setSelectedEducation(null);
          setDeleteEducationModal(false);
        }}
        accept={() =>
          deleteEducation(
            selectedEducation?.ID,
            search,
            pageNumber,
            size,
            toastReff,
            setDeleteEducationModal
          )
        }
      />
      <CustomDataTable
        data={educationsDetails}
        onSearch={handleSearch}
        onAdd={() => setEducationModal(true)}
        totalRecords={totalRecords}
        addButtonTooltip="Add Education"
        columns={EDUCATIONS_COLUMNS}
        onPagination={handlePagination}
        // onSort={handleSort}
      />

      {educationModal && (
        <AddEditEducation
          show={educationModal}
          onHide={() => {
            setEducationModal(false);
            setSelectedEducation(null);
          }}
          getData={()=>getEducationDetailsData(search, pageNumber, size, toastReff)}
          selectedEducation={selectedEducation}
        />
      )}
    </>
  );
}

export default EducationDetails;
